import * as Icons from "./iconImports";
import { Suspense, useMemo } from "react";

interface IconProps {
  icon: string;
  color?: string;
  fill?: string;
  width?: number;
  height?: number;
  inline?: boolean;
  stroke?: string;
}

const StyledIcon = ({
  icon,
  color,
  fill,
  width,
  height,
  inline = false,
  stroke,
}: IconProps) => {
  const getIconComponent = useMemo(() => {
    const iconComponents = {
      x: Icons.XIcon,
      logo: Icons.Logo,
      sort: Icons.Sort,
      map: Icons.MapIcon,
      area: Icons.AreaIcon,
      home: Icons.HomeIcon,
      list: Icons.ListIcon,
      brick: Icons.BrickIcon,
      furnishing: Icons.Furnishing,
      floor: Icons.FloorIcon,
      phone: Icons.PhoneIcon,
      email: Icons.EmailIcon,
      cloud: Icons.CloudIcon,
      image: Icons.ImageIcon,
      agent: Icons.AgentIcons,
      garage: Icons.GarageIcon,
      search: Icons.SearchIcon,
      google: Icons.GoogleIcon,
      filter: Icons.FilterIcon,
      back: Icons.BackArrayIcon,
      parking: Icons.ParkingIcon,
      profile: Icons.ProfileIcon,
      profileHeader: Icons.ProfileHeader,
      topArrow: Icons.TopArrow,
      bottomArrow: Icons.BottomArrow,
      bedroom: Icons.BedroomIcon,
      property: Icons.PropertyIcon,
      verified: Icons.VerifiedIcon,
      bathroom: Icons.BathroomIcon,
      checkbox: Icons.CheckboxIcon,
      facebook: Icons.FacebookIcon,
      pencil: Icons.PencilIcon,
      download: Icons.DownloadIcon,
      telegram: Icons.TelegramIcon,
      dropdown: Icons.DropdownIcon,
      rightArrow: Icons.RightArrow,
      tickCircle: Icons.TickCircle,
      masterCard: Icons.MasterCard,
      instagram: Icons.InstagramIcon,
      caretDown: Icons.CaretDownIcon,
      hamburger: Icons.HamBurgerIcon,
      floorPlan: Icons.FloorPlanIcons,
      locationPin: Icons.LocationPinIcon,
      showPassword: Icons.ShowPasswordIcon,
      confirmation: Icons.ConfirmationIcon,
      hidePassword: Icons.HidePasswordIcon,
      facebookLogin: Icons.FacebookLoginIcon,
      edit: Icons.EditIcon,
      myPropertyIcon: Icons.MyPropertyIcon,
      trash: Icons.TrashIcon,
      notification: Icons.Notification,
      send: Icons.Send,
      openChat: Icons.OpenChat,
      message: Icons.Message,
      logout: Icons.Logout,
      logoutConfirmation: Icons.LogoutConfirmation,
      favourite: Icons.Favourite,
      vyomManaged: Icons.VyomManaged,
      announcementMobile: Icons.AnnouncementMobile,
      threeDots: Icons.ThreeDots,
      closeChat: Icons.CloseChat,
      noFloorPlan: Icons.NoFloorPlan,
      noChats: Icons.NoChats,
      noEnquiries: Icons.NoEnquiries,
      noFavourites: Icons.NoFavourites,
      pendingApproval: Icons.PendingApproval,
      noProperty: Icons.NoProperty,
      noListedProperty: Icons.NoListedProperty,
      noVideo: Icons.NoVideo,
      noPhotos: Icons.NoPhotos,
      noLocation: Icons.NoLocation,
      siren: Icons.Siren,
      eligibleResell: Icons.EligibleResell,
      healthCheck: Icons.HealthCheck,
      healthCheckBtn: Icons.HealthCheckBtn,
      offPlan: Icons.OffPlan,
      paymentFail: Icons.PaymentFail,
      arrowLeft: Icons.ArrowLeft,
      arrowRight: Icons.ArrowRight,
      cancel: Icons.Cancel,
      backArrow: Icons.BackArrayIcon,
      downTriangle: Icons.DownTriangle,
      cancelIcon: Icons.CancelIcon,
      successTickCircle: Icons.SuccessTickIcon,
      scrollArrowLeft: Icons.leftScrollArrow,
      scrollArrowRight: Icons.rightScrollArrow,
      youtube: Icons.Youtube,
      notificationUnread: Icons.NotificationWithDot,
      caretDownSmall: Icons.CaretDownSmall,
      favouriteChecked: Icons.FavouriteChecked,
      fovouriteUnchecked: Icons.FavouriteUnchecked,
      mapPin: Icons.MapPin,
      backArrowWithBackground: Icons.BackArrowWithBackground,
      messageFilled: Icons.messageFilled,
      dialerFilled: Icons.dialerFilled,
      vyomManagedMap: Icons.VyomManagedMap,
      view: Icons.View,
      notFound: Icons.NotFound,
      maintenance: Icons.Maintenance,
      notFoundMobile: Icons.NotFoundMobile,
      contactAgent: Icons.ContactAgent,
      platinum: Icons.Platinum,
      successTick: Icons.SuccessTick,
      successUntick: Icons.SuccessUntick,
      camera: Icons.Camera,
    };

    // @ts-ignore
    return (icon: string) => iconComponents[icon] || Icons.TickCircle;
  }, []);

  const IconComponent = getIconComponent(icon);

  return (
    <Suspense fallback={<div>...</div>}>
      <IconComponent
        style={{
          display: inline ? "inline" : "block",
          color,
          height,
          width,
          fill,
          stroke,
        }}
      />
    </Suspense>
  );
};

export default StyledIcon;
